import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingTableComponent } from './pricing-table.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LoadingModule } from '@ee/common/loading';
import { MatIconModule } from '@angular/material/icon';
import { ProductComponent } from './product/product.component';
import { MatCard, MatCardContent, MatCardHeader } from '@angular/material/card';
import { NgToggleModule } from 'ng-toggle-button';
import { FormsModule } from '@angular/forms';
import { ProductComparisonComponent } from './product-comparison.component';
import { EeDirectivesModule } from '@ee/common/directives';
import { TippyDirective } from '@ngneat/helipopper';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    LoadingModule,
    MatIconModule,
    MatCard,
    MatCardHeader,
    MatCardContent,
    NgToggleModule.forRoot(),
    FormsModule,
    EeDirectivesModule,
    TippyDirective
  ],
  declarations: [PricingTableComponent, ProductComponent, ProductComparisonComponent],
  exports: [PricingTableComponent, ProductComponent, ProductComparisonComponent]
})
export class PricingModule {}
